export type HighlightTextProps = {
    text: string;
    highlight: string;
};

function HighlightText({ text, highlight }: HighlightTextProps) {
    if (!highlight.trim()) {
        return <>{text}</>;
    }

    const regex = new RegExp(`(${highlight})`, "gi");
    const parts = text.split(regex);

    return (
        <>
            {parts.map((part, index) =>
                regex.test(part) ? (
                    <mark key={index} className="bg-yellow-200 text-gray-900 font-semibold rounded px-0.5">
                        {part}
                    </mark>
                ) : (
                    <span key={index}>{part}</span>
                )
            )}
        </>
    );
}

export default HighlightText;
